/* initAnonymous.ts */
import AnalyticsInstance from '@shared/utils/analytics';
import AppConfig from '@shared/classes/app';
import DeviceConfig from '@devices/config';
import FlavourConfig from '../../../shared/config/flavours';
import Focus from '../../types/enums/focus';
import Pages from '@pages';
import Storage from '@storage';
import User from '../../classes/user';
import createIdRequest from '../../api/login/createIdRequest';
import initPlans from '../plans/initPlans';
import unpairDeviceRequest from '../../api/unpair/unpairRequest';
import { _prepareUrl } from '../../../shared/plugins/tokenGenerator/tokenGenerator';
import { clearChannels } from '@shared/store/slices/channels.slice';
import { pushFocus } from '../../store/slices/focus.slice';
import { pushRoute } from '../../store/thunks/route.thunk';
import { setKeepWatchingData } from '@shared/store/slices/keepWatching.slice';
import { setSplash } from '@shared/store/slices/app.slice';
import { store } from '../../store/store';
import {
  clearEvents,
  setLastModifiedDate,
} from '@shared/store/slices/events.slice';
import {
  setUser,
  setInitialized,
  removeInitialized,
  setUserId,
  setCarrier,
} from '../../store/slices/user.slice';

/**
 * Initialize the anonymous user
 * @param logout - Whether to logout the user
 * @param callback - Callback function to call after the anonymous user is initialized
 */
export default async function initAnonymous(
  logout?: boolean,
  callback?: () => void
) {
  Storage.delete('userChannelViewSelection');
  store.dispatch(setKeepWatchingData({ shows: [], rail: undefined }));
  store.dispatch(setCarrier(FlavourConfig.carrierId));
  store.dispatch(setLastModifiedDate(undefined));
  initPlans(async () => {
    const { app } = store.getState();
    const firstLoad = Storage.get('first_load') === '1';
    const token = _prepareUrl('');
    unpairDeviceRequest();
    store.dispatch(removeInitialized());
    Storage.delete('userToken');
    Storage.delete('channelOrder');
    store.dispatch(setUser(User.anonymous()));
    if (app.status.anonymous) {
      if (AnalyticsInstance.isInitialized()) {
        AnalyticsInstance?.getOmnitrackManager()?.setUrl(
          AppConfig.getUrl('freeOmnitrack_link')
        );
      }
      createIdRequest(token).then((response) => {
        store.dispatch(clearChannels());
        store.dispatch(clearEvents());
        store.dispatch(setUserId(response));
        if (!AnalyticsInstance.isInitialized()) {
          AnalyticsInstance.initialize(response);
        }
        store.dispatch(setInitialized());
        if (firstLoad) {
          store.dispatch(
            pushRoute({ route: { Page: Pages.LANGUAGES, overwrite: true } })
          );
        } else {
          setTimeout(() => {
            store.dispatch(
              pushRoute({
                route: {
                  Page: logout ? Pages.LINK : Pages.INITIAL,
                  overwrite: true,
                },
                params: {
                  current: {
                    menuIndex: 0,
                  },
                },
              })
            );
          });
          logout && store.dispatch(pushFocus(Focus.MENU));
        }
        if (callback) {
          callback();
        }
      });
    } else {
      store.dispatch(
        pushRoute({
          route: {
            Page: firstLoad ? Pages.WELCOME : Pages.LANGUAGES,
            overwrite: true,
          },
        })
      );
      store.dispatch(setSplash({ display: false }));
    }

    DeviceConfig?.initAnonymousCallback !== undefined
      ? await DeviceConfig?.initAnonymousCallback()
      : null;
  });
}
